<template>
  <div class="ts-capture_content_container ts-signup-portal">
    <header>
      <h4>Customize your portal</h4>
    </header>

    <el-form @submit.native.prevent>
      <p>
        This is where you will access your
        {{ $t("lorganization") }} portal.<br />Create a memorable unique name
        and be sure to bookmark it once you're inside.
      </p>
      <el-form-item
        :error="retrieveFieldError(modelState, 'portalDomain.subdomain')"
        :required="true"
      >
        <el-input placeholder="Anything" v-model="currentRegistration.portalDomain.subdomain" >
          <template slot="append">.talentsensus.com</template>
        </el-input>
      </el-form-item>

      <div class="form-actions">
        <button
          v-on:click="storeSection()"
          class="ts-btn ts-btn-rounded ts-btn-white"
        >
          Back
        </button>
        <button
          v-on:click="storeSection()"
          class="ts-btn ts-btn-rounded ts-btn-secondary"
        >
          Next
        </button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  created() {
    if (this.currentRegistration.portalDomain == null) {
      this.currentRegistration.portalDomain = {};
    }
  },
  data() {
    return {
      modelState: {},
    };
  },
  computed: {
    currentRegistration() {
      return this.$store.state.registration.current_registration;
    },
  },
  methods: {
    storeSection() {
      this.isLoading = true;

      this.$store
        .dispatch("registration/store", this.currentRegistration)
        .then(() => {
          this.$router.app.$emit("navigateToNextStep");
        })
        .catch((res) => {
          this.modelState = res.errors;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
